import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiLogIn, FiEye, FiEyeOff, FiAlertCircle } from "react-icons/fi";
import { useCustomer } from "../context/ShopContext";
import "./Cart.css"; // reuses your cart form styles

export default function LoginPage() {
  const { login } = useCustomer();
  const navigate   = useNavigate();
  const [form, setForm]       = useState({ email: "", password: "" });
  const [showPw, setShowPw]   = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r    = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.message || "Login failed.");
      login(data.customer, data.token);
      navigate("/shop");
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <main style={{ minHeight: "100vh", background: "#f4f4f7", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px", fontFamily: "'DM Sans', sans-serif" }}>
      <div className="cart-auth" style={{ maxWidth: 420, width: "100%" }}>
        <div className="cart-auth__header">
          <h2>Sign In</h2>
          <p>Welcome back! Enter your credentials to continue.</p>
        </div>
        <form className="cart-auth__form" onSubmit={handleSubmit}>
          {error && (
            <p className="cart-error"><FiAlertCircle size={14} /> {error}</p>
          )}
          <div className="cart-form__group">
            <label>Email address</label>
            <input
              type="email" required
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              placeholder="you@example.com"
            />
          </div>
          <div className="cart-form__group">
            <label>Password</label>
            <div className="cart-pw-wrap">
              <input
                type={showPw ? "text" : "password"} required
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="Your password"
              />
              <button type="button" className="cart-pw-toggle" onClick={() => setShowPw(v => !v)}>
                {showPw ? <FiEyeOff size={15} /> : <FiEye size={15} />}
              </button>
            </div>
          </div>
          <button className="cart-btn cart-btn--primary cart-btn--full" disabled={loading}>
            <FiLogIn size={15} /> {loading ? "Signing in…" : "Sign In"}
          </button>
          <p className="cart-auth__switch">
            Don't have an account? <Link to="/register" style={{ color: "#d62828", fontWeight: 700 }}>Register</Link>
          </p>
          <p className="cart-auth__switch">
            <Link to="/shop" style={{ color: "#888", fontSize: "0.82rem" }}>← Back to shop</Link>
          </p>
        </form>
      </div>
    </main>
  );
}